import { Fragment } from 'react';
import Flex from '@/components/common/Flex';
import { Card, Placeholder } from 'react-bootstrap';
import type { CSSProperties } from 'react';

type NoHeaderAgGridSkeletonProps = {
  height?: CSSProperties['height'];
};

const NoHeaderAgGridSkeleton = ({
  height = '500px'
}: NoHeaderAgGridSkeletonProps) => {
  return (
    <Card className="h-100">
      <Card.Body
        as={Flex}
        direction="column"
        justifyContent="between"
        className="py-2"
      >
        <div
          style={{ height }}
          className="d-flex flex-column justify-content-around  overflow-auto"
        >
          {Array.from({ length: 20 }).map((_, index) => (
            <div
              key={index}
              className="w-100 p-3 d-flex gap-4 align-items-center"
              style={{
                height: 40,
                backgroundColor:
                  index % 2 === 0
                    ? 'var(--falcon-gray-100)'
                    : 'var(--falcon-emphasis-bg) !important'
              }}
            >
              <Placeholder
                style={{ width: 300 }}
                size="xs"
                as="div"
                className="rounded-2"
              />
              <div style={{ width: 100 }} />
              {Array.from({ length: 4 }).map((_, index) => (
                <Fragment key={index}>
                  <Placeholder
                    style={{ width: 150 }}
                    size="xs"
                    as="div"
                    className="rounded-2"
                  />
                  <Placeholder
                    style={{ width: 80 }}
                    size="xs"
                    as="div"
                    className="rounded-2"
                  />
                </Fragment>
              ))}
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default NoHeaderAgGridSkeleton;
